// DS: MO3.4.3 (collectible)
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Props as DeviationShopCardProps } from '../DeviationShopCard/DeviationShopCard';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import { getDeviationPrice } from '../../utils/deviations';

import s from './AdoptableShopCard.exclusives_newstyle.scss';

const CARD_HEIGHT = 380;

export interface Props extends Pick<
  DeviationShopCardProps,
  | 'detailsRightSlot'
  | 'footerSlot'
  | 'allowedIndicators'
  | 'withAuthorDetails'
  | 'withOwnerDetails'
  | 'deviation'
  | 'width'
  | 'overrideHref'
  | 'extraBiData'
> {
  hidePrice?: boolean;
  hideSold?: boolean;
}

const AdoptableShopCardV2: FC<Props> = ({ deviation, width, overrideHref, extraBiData }) => {
  const { t } = useTranslation();
  const height = CARD_HEIGHT;
  const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
  const owner = deviation.adoptable?.owner;
  const formattedDollarsPrice = `$${parseInt(dollarsPrice ?? '0')}`;

  return (
    <div className={s['root']} style={{ width, height }}>
      <DeviationLink
        className={s['link']}
        deviation={deviation}
        overrideHref={overrideHref}
        extraBiData={extraBiData}
        canLinkToStash
        aria-label={t('shop.thumb.a11y.shopLink', {
          username: owner?.username ?? deviation.author?.username,
          deviationName: deviation.title,
          dollarPrice: formattedDollarsPrice,
          count: pointsPrice,
        })}
      />
      <div aria-hidden="true"></div>
    </div>
  );
};
AdoptableShopCardV2.displayName = 'AdoptableShopCard';

export default AdoptableShopCardV2;
